module.exports = __webpack_public_path__ + "img/icon_onboarding_face.9021a0f3.svg";